import "./wdyr.js";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import { loadableReady } from "@loadable/component";
import { createStore } from "../store/redux";
import AppContainer from "../../components/AppContainer/component";
import PageActions from "../../utils/page/library";
import { setup as setupLocalforage } from "../../configuration/localforage";
import { update_feature_cohorts } from "../../actions/FeatureFlags/dispatchers";
import { ScrollRestore } from "../../utils/scroll/library";
import { initializeSentry } from "../../utils/sentry/library";
import { createBrowserHistory } from "history";
import { checkStatsInterface } from "../../utils/stats/library";
import { HelmetProvider } from "react-helmet-async";
import { initMF } from "../../federated/initMF";
import { initAccountCentreMF } from "../../federated/accountCentre/init";
import LandingMaintenance from "../../pages/LandingMaintenance/component";

(async () => {
    initMF(); // Initialize module federation

    await initAccountCentreMF(); // Initialize account centre federation

    const store = createStore(window.__INITIAL_STATE__);
    const maintenance = window?.__MAINTENANCE_MODE__ === "true";
    const featureFlags = store.getState().featureflags;
    const history = createBrowserHistory();
    if (featureFlags?.sentry?.enabled) {
        initializeSentry(featureFlags, history);
    }
    await setupLocalforage(window.__INITIAL_STATE__);
    PageActions.bindEvents();
    store.dispatch(update_feature_cohorts(featureFlags));

    delete window.__INITIAL_STATE__;

    loadableReady(() => {
        hydrateRoot(
            document.getElementById("app"),
            <StrictMode>
                <Provider store={store}>
                    <Router history={history}>
                        <ScrollRestore />
                        <HelmetProvider>
                            {maintenance ? (
                                <LandingMaintenance />
                            ) : (
                                <AppContainer />
                            )}
                        </HelmetProvider>
                    </Router>
                </Provider>
            </StrictMode>
        );
        // expose store when run in Cypress
        if (window.Cypress) {
            window.store = { getState: store.getState };
        }
    });
    checkStatsInterface();
})();
